import React from 'react'
import { l } from '@manychat/manyui'

import { useAppDispatch, useAppSelector } from 'reduxTyped'
import WaCoexistenceContactImportModal from 'apps/whatsApp/components/WaCoexistenceContactImportModal/WaCoexistenceContactImportModal'
import { getWhatsAppCoexistenceContactImportDeadline } from 'common/builder/selectors/builder/whatsAppSelectors'
import { openWaCoexistenceContactImportModal } from 'common/core/actions/uiActions'
import { analyticsService } from 'utils/services/analytics'

import cm from '../StaticNotifications.module.css'

export const WaCoexistenceContactImportAvailableNotification = () => {
  const dispatch = useAppDispatch()

  const { hoursLeft, deadlineWithTimezone } = useAppSelector(
    getWhatsAppCoexistenceContactImportDeadline,
  )

  const handleShowMore = () => {
    dispatch(openWaCoexistenceContactImportModal())
    analyticsService.sendEvent(
      'NOTIFICATION_BAR.WA_COEXISTENCE_CONTACTS_NEED_TO_BE_IMPORTED.SHOW_MORE.CLICK',
    )
  }

  return (
    <div>
      <span>
        {l.translate(
          'You have {hoursLeft} hours until {deadline} to import contacts from your WhatsApp Business App to continue engaging with them on Manychat.',
          { hoursLeft, deadline: deadlineWithTimezone },
        )}
      </span>{' '}
      <span className={cm.readMore} onClick={handleShowMore}>
        {l.translate('Show more')}
      </span>
      <WaCoexistenceContactImportModal />
    </div>
  )
}
